var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"cms-block-stub"},[_c('div',{class:_vm.cfgs.container_class,domProps:{"innerHTML":_vm._s(_vm.values.text)}})])}
var staticRenderFns = []

export { render, staticRenderFns }